import { gql } from '@apollo/client';

export const DELETE_GENERIC_ENTITY_FLOW_TRANSITION = gql`
  mutation deleteGenericEntityFlowTransition($input: TransitionToDeleteInput) {
    deleteGenericEntityFlowTransition(input: $input) {
      commandId
    }
  }
`;
